export default {
    ADD_TO_CART: 'addToCart',
    UPDATE_CHECKOUT_DATA: 'updateCheckoutData',
    ADD_COUPON: 'addCoupon',
    REMOVE_COUPON: 'removeCoupon',
    FETCH_CUSTOMER: 'fetchCustomer',
    DEFAULT_CUSTOMER: {
        id: '',
        email: '',
        firstName: '',
        lastName: '',
        mfa: {},
        billingEmail: '',
        billingAddress: {
            first_name: '',
            last_name: '',
            city: '',
            state: 'TX',
            postcode: '',
            address_1: '',
            address_2: '',
            country: 'US'
        },
        savedPaymentMethods: []
    }
}
